"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const e_1 = require("e");
const bank_1 = require("../util/bank");
const itemID_1 = __importDefault(require("../util/itemID"));
const Items_1 = __importDefault(require("./Items"));
class Bank {
    constructor(initialBank) {
        this.bank = initialBank ? bank_1.resolveBank(initialBank) : {};
    }
    amount(item) {
        var _a;
        return (_a = this.bank[typeof item === 'string' ? itemID_1.default(item) : item]) !== null && _a !== void 0 ? _a : 0;
    }
    addItem(item, quantity = 1) {
        if (quantity < 1)
            return this;
        if (this.bank[item])
            this.bank[item] += quantity;
        else
            this.bank[item] = quantity;
        return this;
    }
    removeItem(item, quantity = 1) {
        const currentValue = this.bank[item];
        if (typeof currentValue === 'undefined')
            return this;
        if (currentValue - quantity <= 0) {
            delete this.bank[item];
        }
        else {
            this.bank[item] = currentValue - quantity;
        }
        return this;
    }
    add(item, quantity = 1) {
        if (!item) {
            return this;
        }
        // Bank.add(123);
        if (typeof item === 'number') {
            return this.addItem(item, quantity);
        }
        if (Array.isArray(item)) {
            for (const _item of item)
                this.addItem(_item.item, _item.quantity);
            return this;
        }
        // Bank.add('Twisted bow');
        // Bank.add('Twisted bow', 5);
        if (typeof item === 'string') {
            return this.addItem(itemID_1.default(item), quantity);
        }
        if (item instanceof Bank) {
            return this.add(item.bank);
        }
        const firstKey = Object.keys(item)[0];
        if (firstKey === undefined) {
            return this;
        }
        if (isNaN(Number(firstKey))) {
            this.add(bank_1.resolveNameBank(item));
        }
        else {
            this.bank = bank_1.addBanks([item, this.bank]);
        }
        return this;
    }
    remove(item, quantity = 1) {
        if (Array.isArray(item)) {
            for (const _item of item)
                this.remove(_item.item, _item.quantity);
            return this;
        }
        // Bank.remove('Twisted bow');
        // Bank.remove('Twisted bow', 5);
        if (typeof item === 'string') {
            return this.removeItem(itemID_1.default(item), quantity);
        }
        // Bank.remove(123);
        if (typeof item === 'number') {
            return this.removeItem(item, quantity);
        }
        if (item instanceof Bank) {
            return this.remove(item.bank);
        }
        const firstKey = Object.keys(item)[0];
        if (firstKey === undefined) {
            return this;
        }
        if (isNaN(Number(firstKey))) {
            this.remove(bank_1.resolveNameBank(item));
        }
        else {
            this.bank = bank_1.removeBankFromBank(this.bank, item);
        }
        return this;
    }
    random() {
        const entries = e_1.objectEntries(this.bank);
        if (entries.length === 0)
            return null;
        const randomEntry = e_1.randArrItem(entries);
        return { id: Number(randomEntry[0]), qty: randomEntry[1] };
    }
    multiply(multiplier) {
        this.bank = bank_1.multiplyBank(this.bank, multiplier);
        return this;
    }
    has(items) {
        if (Array.isArray(items)) {
            return items.every((item) => this.amount(item) > 0);
        }
        if (typeof items === 'string' || typeof items === 'number') {
            return this.amount(items) > 0;
        }
        return bank_1.bankHasAllItemsFromBank(this.bank, items);
    }
    items() {
        const arr = [];
        for (const [key, val] of Object.entries(this.bank)) {
            arr.push([Items_1.default.get(parseInt(key)), val]);
        }
        return arr;
    }
    forEach(fn) {
        for (const item of this.items()) {
            fn(...item);
        }
    }
    clone() {
        return new Bank(Object.assign({}, this.bank));
    }
    fits(bank) {
        var _a;
        const items = bank.items();
        const divisions = items
            .map(([item, qty]) => Math.floor(this.amount(item.id) / qty))
            .sort((a, b) => a - b);
        return (_a = divisions[0]) !== null && _a !== void 0 ? _a : 0;
    }
    filter(fn, mutate = false) {
        const result = new Bank();
        for (const item of this.items()) {
            if (fn(...item)) {
                result.add(item[0].id, item[1]);
            }
        }
        if (mutate) {
            this.bank = result.bank;
            return this;
        }
        return result;
    }
    values() {
        return this.bank;
    }
    toString() {
        var _a, _b;
        const entries = Object.entries(this.bank);
        if (entries.length === 0) {
            return `No items`;
        }
        const res = [];
        for (const [id, qty] of entries.sort((a, b) => b[1] - a[1])) {
            res.push(`${qty.toLocaleString()}x ${(_b = (_a = Items_1.default.get(Number(id))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'Unknown item'}`);
        }
        return res.join(', ');
    }
    get length() {
        return Object.keys(this.bank).length;
    }
    value() {
        let value = 0;
        for (const [item, quantity] of this.items()) {
            value += item.price * quantity;
        }
        return value;
    }
}
exports.default = Bank;
//# sourceMappingURL=Bank.js.map